import { render, staticRenderFns } from "./RecentConversationsIcon.vue?vue&type=template&id=f14d49ce&"
import script from "./RecentConversationsIcon.vue?vue&type=script&lang=js&"
export * from "./RecentConversationsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports